// Core Imports
import React from 'react';
import { Carousel } from 'react-bootstrap';

// Image Assets
import Slider1 from '../assets/images/homepage/home-slide-1.jpeg';
import Slider2 from '../assets/images/homepage/home-slide-2.jpeg';
import Slider3 from '../assets/images/homepage/home-slide-3.jpeg';

const Slider = () => {
  return (
    // Hide on extra-small devices
    <div className="slider d-none d-sm-block">
      <Carousel controls={false} interval={5000} fade>
        
        {/* Slide 1 */}
        <Carousel.Item>
          <div className="slider-image-wrapper">
            <img 
              className="d-block w-100 slider-img" 
              src={Slider1} 
              alt="construction1" 
            />
            <div className="slider-overlay" /> {/* Semi-transparent overlay */}
          </div>
          <Carousel.Caption className="carousal-text">
            <h2>Building it right — from the ground up</h2>
            <p className="mb-0">From earthworks and civil works - to residential, commercial, and interior construction</p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 2 */}
        <Carousel.Item>
          <div className="slider-image-wrapper">
            <img 
              className="d-block w-100 slider-img" 
              src={Slider2} 
              alt="construction2" 
            />
            <div className="slider-overlay" />
          </div>
          <Carousel.Caption>
            <h2>Building it right — from the ground up</h2>
            <p className="mb-0">From earthworks and civil works - to residential, commercial, and interior construction</p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 3 */}
        <Carousel.Item>
          <div className="slider-image-wrapper">
            <img 
              className="d-block w-100 slider-img" 
              src={Slider3} 
              alt="construction3" 
            />
            <div className="slider-overlay" />
          </div>
          <Carousel.Caption>
            <h2>Building it right — from the ground up</h2>
            <p className="mb-0">From earthworks and civil works - to residential, commercial, and interior construction</p>
          </Carousel.Caption>
        </Carousel.Item>

      </Carousel>
    </div>
  );
};

export default Slider;
